import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { Tabs, TabsList, TabsTrigger } from './chart-tabs'
import {
  useProductDetailPriceHistories,
  DurationType,
} from '@/shared/ui/history-chart-component/use-product-detail-price-histories'
export const HistoryChartTab = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  const { duration, onChangeDuration } = useProductDetailPriceHistories()

  return (
    <div className={cn('w-full', className)} {...props}>
      <Tabs
        defaultValue={duration}
        className="w-full"
        onValueChange={(value) => onChangeDuration(value as DurationType)}
      >
        <TabsList className="w-full bg-gray-2">
          <TabsTrigger className="grow" value="2주">
            2주
          </TabsTrigger>
          <TabsTrigger className="grow" value="2개월">
            2개월
          </TabsTrigger>
          <TabsTrigger className="grow" value="6개월">
            6개월
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
